var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Leads") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Leads"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-98",
    fill: "#FF8B00",
    x: 0,
    y: 0,
    width: 500,
    height: 500,
    rx: 50
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(70.000000, 56.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7112205,136.347826 L324.746503,136.347826 C330.26935,136.347826 334.746503,140.824979 334.746503,146.347826 C334.746503,149.545837 333.216951,152.550953 330.631327,154.432926 L265.168131,202.080997 C256.491868,208.396105 252.37904,219.249893 254.691484,229.728954 L275.992198,326.255188 C277.182308,331.648284 273.775114,336.985027 268.382019,338.175136 C264.83296,338.958317 261.138396,337.754264 258.732306,335.03031 L196.152699,264.183404 C186.280806,253.00735 169.218074,251.950118 158.04202,261.822011 C157.187944,262.576423 156.382485,263.384149 155.630476,264.240342 L93.2817441,335.226932 C89.6371343,339.37647 83.3187293,339.785795 79.1691915,336.141185 C76.4506481,333.753442 75.2339737,330.083425 75.9877408,326.544551 L96.7126472,229.242834 C98.8922163,219.009938 94.9638316,208.438978 86.6305929,202.112856 L23.6647143,154.312734 C19.265817,150.973341 18.4069192,144.700217 21.7463124,140.30132 C23.6371019,137.810631 26.5841429,136.347826 29.7112205,136.347826 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 177.73913,
    cy: 51.1304348,
    r: 39.1304348
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLead);
export default __webpack_public_path__ + "static/media/icon-lead.5bd13951f5e42002366484af51cb7017.svg";
export { ForwardRef as ReactComponent };